module.exports = __webpack_public_path__ + "img/four3Red.054d6d52.png";